import ModalBase from "modals/base/ModalBase";
import style from "./PromotionEditModal.module.css";
import NiceModal from "@ebay/nice-modal-react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import P from "components/P";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import { useEffect } from "react";
import { adminRequester, requester } from "App";
import { useState } from "react";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import RangeSlider from "components/inputs/rangeSlider/RangeSlider";
import Center from "layouts/wrapper/Center";
import initialSearchCondition from "InitialData/InitialSearchCondition.json";
import Inline from "layouts/container/Inline";
import QuillViewer from "components/inputs/richEditor/QuillViewer";
import QuillEditor from "components/inputs/richEditor/QuillEditor";
import { decode } from "shared/utils/Utils";
import ToolTip from "components/tooltip/tooltip";
import InputText from "components/inputs/InputText";
import DatePicker from "components/inputs/datePicker/DatePicker";
import InputNumber from "components/inputs/InputNumber";
import ToolTipGroup from "components/tooltip/tooltipGroup";
import ToolTipChild from "components/tooltip/tooltipChild";
import CustomButton from "components/buttons/CustomButton";

const PromotionEditModal = NiceModal.create((props, ref) => {
  const modal = useRef();
  const { t } = useTranslation();
  const [isMounted, setMounted] = useState(false);
  const [withHeader, withFooter] = [true, false];
  // const [width, height] = [props.width || "60%", props.height || "50%"];
  const [width, height] = [
    props.width || "min(95%, 1200px)",
    props.height || "80vh",
  ];
  const withCloseButton = true;
  const clickOutsideToClose = true;
  const { data } = props;
  const dateRef = useRef();
  const [startDate, setStartDate] = useState();
  const [endDate, setsEndDate] = useState();
  const title = "프로모션 편집";
  const buttonText = "close";
  const inputs = useRef([]);
  const maxDate = new Date();
  const [variants, setVariants] = useState([]);
  const [products, setProducts] = useState([]);
  const [mixYn, setMixYn] = useState();
  const [cross, setCross] = useState(data?.cross || false);
  const productsTips = useRef([]);
  const produdctsTipGroup = useRef();
  const variantsTips = useRef([]);
  const variantsTipGroup = useRef();
  maxDate.setFullYear(maxDate.getFullYear() + 10);
  useEffect(() => {
    setMounted(true);
  }, []);
  useEffect(() => {
    if (isMounted) {
      setStartDate(new Date(data.start_date));
      setsEndDate(new Date(data.end_date));
      switch (data.type) {
        case "discount": {
          data.rule.conditions.forEach((condtion) => {
            switch (condtion.type) {
              case "products": {
                setProducts(condtion.products);
                break;
              }
              case "variants": {
                setVariants(condtion.variants);
                break;
              }
              default:
                break;
            }
          });
          break;
        }
        case "event": {
          setProducts(data.products);
          setMixYn(data.cross);
          break;
        }
        default:
          break;
      }
    }
  }, [isMounted]);
  const initializationStyle = {
    backgroundColor: "white",
    padding: "7px 20px",
    color: "black",
    border: "1px solid #ddd",
  };
  const onSelectVariantClick = () => {
    NiceModal.show("adminCheckSelect", {
      title: "옵션 선택",
      code: "variants",
      request: (...props) => adminRequester.getVariants(...props),
      onSelect: (result) =>
        setVariants([
          ...variants,
          ...result.filter((f) => !variants.some((v) => v.id === f.id)),
        ]),
      headers: [
        {
          code: "thumbnail",
          label: "썸네일",
          type: "image",
          width: "60px",
        },
        { code: "id", label: "옵션ID" },
        { code: "title", label: "옵션명" },
      ],
      Search: ({ callback }) => (
        <input
          type="text"
          onKeyDown={(e) => {
            if (e.key === "Enter") callback({ t: e.target.value });
          }}
          style={{
            outline: "none",
            backgroundColor: "rgb(233, 233, 233)",
            borderRadius: "10px",
            marginLeft: "auto",
            paddingRight: "10px",
            paddingLeft: "10px",
            minWidth: "250px",
          }}
          placeholder="search..."
        />
      ),
    });
  };
  const onSelectProductClick = () => {
    NiceModal.show("adminCheckSelect", {
      title: "상품 선택",
      request: (...props) => adminRequester.getProducts(...props),
      code: "products",
      onSelect: (result) =>
        setProducts([
          ...products,
          ...result.filter((f) => !products.some((p) => p.id === f.id)),
        ]),
      headers: [
        {
          code: "thumbnail",
          label: "썸네일",
          type: "image",
          width: "60px",
        },
        { code: "id", label: "상품ID" },
        { code: "title", label: "제목" },
      ],
      Search: ({ callback }) => (
        <input
          type="text"
          onKeyDown={(e) => {
            if (e.key === "Enter") callback({ t: e.target.value });
          }}
          className={style.input}
          placeholder="search..."
        />
      ),
    });
  };
  const onCancelClick = () => {
    modal.current.close();
  };
  const onSaveClick = () => {
    const title = inputs.current[0].getValue();
    if (data.type === "discount") {
      let conditions = [];
      if (
        !data.rule.conditions.some(
          (condition) => condition.type === "products"
        ) &&
        products?.length > 0
      )
        conditions.push({
          type: "products",
          operator: "in",
          products: products?.map((product) => product.id),
        });
      if (
        !data.rule.conditions.some(
          (condition) => condition.type === "variants"
        ) &&
        variants?.length > 0
      )
        conditions.push({
          type: "variants",
          operator: "in",
          variants: variants?.map((variant) => variant.id),
        });
      const value = inputs.current[1].getValue();
      adminRequester.updateDiscount(
        data.id,
        {
          title: title,
          starts_at: dateRef.current.getStartDate(),
          ends_at: dateRef.current.getEndDate(),
          rule: {
            ...data.rule,
            value: value,
            conditions: conditions,
          },
        },
        () => {
          if (data.rule.conditions?.length === 0) {
            props?.setReload(true);
          } else {
            Promise.all(
              data.rule.conditions.map((condition) =>
                adminRequester.updateDiscountCondition(
                  data.id,
                  condition.id,
                  {
                    override: true,
                    resources:
                      condition.type === "products"
                        ? products.map((product) => ({ id: product.id }))
                        : condition.type === "variants"
                        ? variants.map((variant) => ({ id: variant.id }))
                        : [],
                  },
                  () => {}
                )
              )
            ).then(() => props?.setReload(true));
          }
        }
      );
      // rule: {
      //   ...data.rule,
      //   conditions: conditions,
      // },
    } else {
      const N = inputs.current[1].getValue();
      const M = inputs.current[2].getValue();
      adminRequester.updateEvent(
        data.id,
        {
          title: title,
          start_date: dateRef.current.getStartDate(),
          end_date: dateRef.current.getEndDate(),
          products: products,
          N: N,
          M: M,
          cross: cross,
        },
        () => props?.setReload(true)
      );
      // variants;
    }
    modal.current.close();
  };
  return (
    <ModalBase
      ref={modal}
      width={width}
      maxWidth={props.maxWidth}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
      title={title}
      buttonText={buttonText}
    >
      <PaddingWrapper padding={30}>
        <VerticalFlex gap={20}>
          <FlexChild>
            <HorizontalFlex gap={20}>
              <FlexChild width={"88px"}>
                <P weight={"bold"}>프로모션 상세</P>
              </FlexChild>
              <FlexChild>
                <div
                  className={style.label}
                  style={{
                    width: "max-content",
                    backgroundColor:
                      data.type === "event" ? "#e84518" : "#5471e6",
                  }}
                >
                  <P padding={5} width="max-content">
                    {t(data.type)}
                  </P>
                </div>
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
          <FlexChild>
            <HorizontalFlex gap={20}>
              <FlexChild width={"88px"}>
                <P weight={"bold"}>제목</P>
              </FlexChild>
              <FlexChild>
                <InputText
                  ref={(el) => (inputs.current[0] = el)}
                  value={data.title}
                />
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
          <FlexChild>
            <HorizontalFlex gap={20}>
              <FlexChild width={"88px"}>
                <P weight={"bold"}>기간</P>
              </FlexChild>
              <FlexChild>
                <FlexChild width={"initial"}>
                  {/* <P size={15}>{formatDateTime(data.start_date)}</P>
                <P> ~ </P>
                <P size={15}>{formatDateTime(data.end_date)}</P> */}
                  <DatePicker
                    ref={dateRef}
                    maxDate={maxDate}
                    type={"time"}
                    startDate={new Date(data.start_date)}
                    endDate={new Date(data.end_date)}
                    onChange={() => {}}
                  />
                </FlexChild>
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
          <FlexChild>
            <HorizontalFlex gap={20}>
              <FlexChild width={"88px"}>
                <P weight={"bold"}>이벤트 내용</P>
              </FlexChild>
              <FlexChild>
                {data.type === "discount" ? (
                  <HorizontalFlex>
                    <FlexChild width={"100px"}>
                      <InputNumber
                        borderless
                        hideArrow
                        style={{
                          color: "var(--main-color)",
                          fontWeight: "bold",
                        }}
                        ref={(el) => (inputs.current[1] = el)}
                        value={data.rule.value}
                        min={0}
                        max={100}
                      />
                    </FlexChild>
                    <FlexChild>
                      <Inline>
                        <P
                          size={18}
                          color={"var(--main-color)"}
                          weight={"bold"}
                        >
                          %{" "}
                        </P>
                        <P weight={"bold"}>할인</P>
                      </Inline>
                    </FlexChild>
                  </HorizontalFlex>
                ) : (
                  <Inline>
                    <P color={"var(--main-color)"} size={18} weight={"bold"}>
                      <InputNumber
                        borderless
                        hideArrow
                        style={{
                          color: "var(--main-color)",
                          fontWeight: "bold",
                          width: "48px",
                        }}
                        ref={(el) => (inputs.current[1] = el)}
                        value={data.N}
                        min={0}
                        max={100}
                      />
                    </P>
                    <P weight={"bold"} size={13}>
                      개 구입시
                    </P>
                    <P color={"var(--main-color)"} size={18} weight={"bold"}>
                      {" "}
                      +
                    </P>
                    <P color={"var(--main-color)"} size={18} weight={"bold"}>
                      <InputNumber
                        borderless
                        hideArrow
                        style={{
                          color: "var(--main-color)",
                          fontWeight: "bold",
                          width: "48px",
                        }}
                        ref={(el) => (inputs.current[2] = el)}
                        value={data.M}
                        min={0}
                        max={100}
                      />
                    </P>
                    <P weight={"bold"} size={13}>
                      증정
                    </P>
                    <P
                      weight={"bold"}
                      size={11}
                      hover
                      cursor
                      onClick={() => setCross(!cross)}
                    >
                      {" "}
                      ({cross ? "교차 가능" : "교차 불가"})
                    </P>
                  </Inline>
                )}
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
          <FlexChild>
            <HorizontalFlex gap={20} flexStart>
              <FlexChild width={"88px"}>
                <VerticalFlex alignItems="flex-start">
                  <FlexChild width="max-content">
                    <P weight={"bold"}>상품</P>
                  </FlexChild>
                  <FlexChild width="max-content">
                    <CustomButton
                      text={"추가"}
                      style={initializationStyle}
                      onClick={onSelectProductClick}
                    />
                  </FlexChild>
                </VerticalFlex>
              </FlexChild>
              <FlexChild>
                {/* <div
                  style={{
                    height: `${data.type === "event" ? 28 : 13}vh`,
                    overflowY: "scroll",
                  }}
                >
                  <VerticalFlex flexStart>
                    {products?.map((row, index) => {
                      return <DrawItem row={row} />;
                    }) || (
                      <FlexChild>
                        <P>없음</P>
                      </FlexChild>
                    )}
                  </VerticalFlex>
                </div> */}
                <ToolTipGroup ref={produdctsTipGroup} tips={productsTips}>
                  <div
                    style={{
                      height: `${data.type === "event" ? 28 : 13}vh`,
                      overflowY: "scroll",
                    }}
                  >
                    <VerticalFlex flexStart>
                      {products?.map((row, index) => (
                        <DrawItem
                          key={row.id}
                          row={row}
                          index={index}
                          tipGroup={produdctsTipGroup}
                          tips={productsTips}
                          onClick={() =>
                            setProducts([
                              ...products.filter((p) => p.id !== row.id),
                            ])
                          }
                        />
                      )) || (
                        <FlexChild>
                          <P>없음</P>
                        </FlexChild>
                      )}
                    </VerticalFlex>
                  </div>
                </ToolTipGroup>
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
          {data.type === "discount" && (
            <FlexChild>
              <HorizontalFlex gap={20} flexStart>
                <FlexChild width={"88px"}>
                  <VerticalFlex alignItems="flex-start">
                    <FlexChild width="max-content">
                      <P weight={"bold"}>옵션</P>
                    </FlexChild>
                    <FlexChild width="max-content">
                      <CustomButton
                        text={"추가"}
                        style={initializationStyle}
                        onClick={onSelectVariantClick}
                      />
                    </FlexChild>
                  </VerticalFlex>
                </FlexChild>
                <FlexChild>
                  <ToolTipGroup ref={variantsTipGroup} tips={variantsTips}>
                    <div style={{ height: "13vh", overflowY: "scroll" }}>
                      <VerticalFlex flexStart>
                        {variants?.map((row, index) => (
                          <DrawItem
                            key={row.id}
                            row={row}
                            index={index}
                            tipGroup={variantsTipGroup}
                            tips={variantsTips}
                            onClick={() =>
                              setVariants([
                                ...variants.filter((v) => v.id !== row.id),
                              ])
                            }
                          />
                        ))}
                      </VerticalFlex>
                    </div>
                  </ToolTipGroup>
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
          )}
          <HorizontalFlex gap={10} justifyContent="center">
            <FlexChild width="max-content">
              <CustomButton onClick={onCancelClick} text="취소" />
            </FlexChild>
            <FlexChild width="max-content">
              <CustomButton onClick={onSaveClick} text="수정" />
            </FlexChild>
          </HorizontalFlex>
        </VerticalFlex>
      </PaddingWrapper>
    </ModalBase>
  );
});

const DrawItem = ({ row, tips, tipGroup, index, onClick }) => (
  <HorizontalFlex key={row.id}>
    <FlexChild width="max-content">
      <ToolTipChild
        ref={(el) => (tips.current[index] = el)}
        group={tipGroup}
        title={
          <img
            style={{
              height: "10vh",
            }}
            src={row.thumbnail}
            alt="t"
          />
        }
      >
        <img
          style={{ width: "21px", height: "21px" }}
          src={row.thumbnail}
          alt="t"
        />
      </ToolTipChild>
    </FlexChild>
    <FlexChild>
      <P> {row.title}</P>
    </FlexChild>
    <FlexChild>
      <button onClick={onClick}>X</button>
    </FlexChild>
  </HorizontalFlex>
);
export default PromotionEditModal;
